"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chapter = void 0;
var preact_1 = require("preact");
var Chapter = function () { return ((0, preact_1.h)("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" },
    (0, preact_1.h)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4 4C4 3.44772 4.44772 3 5 3H11C11.5523 3 12 3.44772 12 4V13C12 13.824 11.0592 14.2944 10.4 13.8L8.6 12.45C8.24444 12.1833 7.75556 12.1833 7.4 12.45L5.6 13.8C4.94076 14.2944 4 13.824 4 13V4Z", fill: "white" }))); };
exports.Chapter = Chapter;
//# sourceMappingURL=chapter.js.map